import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.CompanySectorStep', {
    title: 'Company sector',
    requiredField: 'Field is required',
    documentsRequired: 'Documents are required',
});
